<template>
  <div
    class=" flex flex-direction justify-center align-center login-container min-body-height"
  >
    <el-card :class="UI.isMobile ? 'full-item' : 'margin-bottom-50'">
      <div slot="header" class="clearfix">
        <span>{{ User.user_info.name ? '修改注册信息' : '信息注册' }}</span>
      </div>
      <UserInfo
        :class="UI.isMobile ? 'mobile-login-box' : 'login-box'"
      ></UserInfo>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import UserInfo from './userInfo.vue';

export default {
  components: {
    UserInfo,
  },

  computed: {
    ...mapState(['UI', 'User']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/userInfoApprove/index.vue